var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.$currentUser.role == "account"
      ? _c("div", { staticClass: "main-content bg-white" }, [
          _c("h3", { staticClass: "page-title" }, [_vm._v("Отчёт по офферам")])
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.$currentUser.role != "account"
      ? _c(
          "div",
          { staticClass: "main-content bg-white" },
          [
            _vm._m(0),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col lg-12" },
                [
                  _c(
                    "b-alert",
                    {
                      attrs: { variant: "danger", dismissible: "" },
                      model: {
                        value: _vm.showDismissibleAlert,
                        callback: function($$v) {
                          _vm.showDismissibleAlert = $$v
                        },
                        expression: "showDismissibleAlert"
                      }
                    },
                    [_c("span", [_vm._v(_vm._s(_vm.alertText))])]
                  )
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row mb-2" }, [
              _c(
                "div",
                { staticClass: "col-sm-4 col-md-3 col-lg-3 col-xl-2" },
                [
                  _c(
                    "b-btn",
                    {
                      directives: [
                        {
                          name: "b-modal",
                          rawName: "v-b-modal.createOffer",
                          modifiers: { createOffer: true }
                        }
                      ],
                      staticClass: "mainButton filterComponent",
                      staticStyle: { "white-space": "nowrap" },
                      attrs: { size: "sm", variant: "success" }
                    },
                    [_vm._v("\n          Добавить оффер\n          ")]
                  )
                ],
                1
              ),
              _vm._v(" "),
              !_vm.isMobile
                ? _c(
                    "div",
                    { staticClass: "col-sm-3 col-md-3 col-lg-2 col-xl-2 mb-2" },
                    [
                      _c(
                        "b-button-group",
                        {
                          staticClass: "filterComponent",
                          staticStyle: { width: "100%!important" }
                        },
                        [
                          _c(
                            "b-button",
                            {
                              staticClass: "mr-1",
                              attrs: { variant: "success", size: "sm" },
                              on: { click: _vm.selectAllRows }
                            },
                            [
                              _c("i", {
                                staticClass: "icon-fa icon-fa-check-square-o"
                              })
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-button",
                            {
                              staticClass: "mr-1",
                              attrs: { variant: "danger", size: "sm" },
                              on: { click: _vm.unselectAllRows }
                            },
                            [_c("i", { staticClass: "icon-fa icon-fa-close" })]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-button",
                            {
                              staticClass: "mr-1",
                              attrs: { variant: "primary", size: "sm" },
                              on: { click: _vm.openMassUpdateModal }
                            },
                            [_c("i", { staticClass: "icon-fa icon-fa-edit" })]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row mb-2" }, [
              _c(
                "div",
                { staticClass: "col-sm-4 col-md-3 col-lg-2 col-xl-2 mb-2" },
                [
                  _c("b-form-input", {
                    staticClass: "sizePlus",
                    attrs: { placeholder: "Поиск:", size: "sm" },
                    model: {
                      value: _vm.search,
                      callback: function($$v) {
                        _vm.search = $$v
                      },
                      expression: "search"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  key: _vm.dateRange,
                  staticClass: "col-sm-4 col-md-3 col-lg-3 col-xl-2 mb-2"
                },
                [
                  _vm.isXl
                    ? _c(
                        "b-button-group",
                        { staticClass: "datePickerXl" },
                        [
                          _c("date-range-picker", {
                            ref: "picker",
                            attrs: {
                              "locale-data": _vm.dateRangeLocalFormat,
                              opens: "right",
                              ranges: _vm.dateRanges
                            },
                            on: {
                              update: function($event) {
                                return _vm.selectRange($event)
                              }
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "input",
                                  fn: function(picker) {
                                    return [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(
                                            _vm._f("formatDateRange")(
                                              _vm.range.startDate
                                            )
                                          ) +
                                          " - " +
                                          _vm._s(
                                            _vm._f("formatDateRange")(
                                              _vm.range.endDate
                                            )
                                          ) +
                                          "\n            "
                                      )
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              365938979
                            ),
                            model: {
                              value: _vm.range,
                              callback: function($$v) {
                                _vm.range = $$v
                              },
                              expression: "range"
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "b-button",
                            { attrs: { size: "sm", variant: "primary" } },
                            [
                              _c("i", {
                                staticClass: "icon-fa icon-fa-calendar-check-o"
                              })
                            ]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.isXl
                    ? _c(
                        "b-input-group",
                        { key: _vm.dateRange },
                        [
                          _c("div"),
                          _vm._v(" "),
                          _c(
                            "b-input-group-append",
                            [
                              _c("datepicker", {
                                staticClass: "date dateLeft",
                                attrs: {
                                  "input-class": "form-control dateFrom",
                                  size: "sm",
                                  "monday-first": "",
                                  language: _vm.ru,
                                  placeholder: "С:"
                                },
                                model: {
                                  value: _vm.range.startDate,
                                  callback: function($$v) {
                                    _vm.$set(_vm.range, "startDate", $$v)
                                  },
                                  expression: "range.startDate"
                                }
                              }),
                              _vm._v(" "),
                              _c("datepicker", {
                                staticClass: "date dateRight",
                                attrs: {
                                  "input-class": "form-control dateTo",
                                  size: "sm",
                                  language: _vm.ru,
                                  "monday-first": "",
                                  placeholder: "По:"
                                },
                                model: {
                                  value: _vm.range.endDate,
                                  callback: function($$v) {
                                    _vm.$set(_vm.range, "endDate", $$v)
                                  },
                                  expression: "range.endDate"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-sm-4 col-md-3 col-lg-2 col-xl-2 mb-2" },
                [
                  _c(
                    "b-form-select",
                    {
                      staticClass: "sizePlus",
                      attrs: { size: "sm", options: _vm.users },
                      model: {
                        value: _vm.user,
                        callback: function($$v) {
                          _vm.user = $$v
                        },
                        expression: "user"
                      }
                    },
                    [
                      _c(
                        "option",
                        { attrs: { disabled: "" }, domProps: { value: null } },
                        [_vm._v("Создатель")]
                      )
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-sm-4 col-md-3 col-lg-2 col-xl-2 mb-2" },
                [
                  _c(
                    "v-select",
                    {
                      staticClass: "geoComponent",
                      attrs: {
                        label: "name",
                        options: _vm.geo,
                        size: "sm",
                        required: "",
                        placeholder: "ГЕО",
                        multiple: ""
                      },
                      model: {
                        value: _vm.selectedGeo,
                        callback: function($$v) {
                          _vm.selectedGeo = $$v
                        },
                        expression: "selectedGeo"
                      }
                    },
                    [
                      _c(
                        "span",
                        { attrs: { slot: "no-options" }, slot: "no-options" },
                        [_vm._v("Совпадений не найдено.")]
                      )
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-sm-4 col-md-3 col-lg-3 col-xl-2 mb-2" },
                [
                  _c(
                    "v-select",
                    {
                      attrs: {
                        size: "sm",
                        options: _vm.advertisers,
                        placeholder: "Рекламодатель",
                        reduce: function(advertiser) {
                          return advertiser.value
                        },
                        required: "",
                        multiple: ""
                      },
                      model: {
                        value: _vm.selectedAdvertisers,
                        callback: function($$v) {
                          _vm.selectedAdvertisers = $$v
                        },
                        expression: "selectedAdvertisers"
                      }
                    },
                    [
                      _c(
                        "span",
                        { attrs: { slot: "no-options" }, slot: "no-options" },
                        [_vm._v("Совпадений не найдено.")]
                      )
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-sm-4 col-md-3 col-lg-3 col-xl-2 mb-2" },
                [
                  _c(
                    "v-select",
                    {
                      attrs: {
                        size: "sm",
                        options: _vm.types,
                        reduce: function(type) {
                          return type.value
                        },
                        placeholder: "Тип",
                        required: "",
                        multiple: ""
                      },
                      model: {
                        value: _vm.selectedTypes,
                        callback: function($$v) {
                          _vm.selectedTypes = $$v
                        },
                        expression: "selectedTypes"
                      }
                    },
                    [
                      _c(
                        "span",
                        { attrs: { slot: "no-options" }, slot: "no-options" },
                        [_vm._v("Совпадений не найдено.")]
                      )
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "myOffers col-sm-4 col-md-3 col-lg-2 col-xl-2 mb-2"
                },
                [
                  _c(
                    "b-form-checkbox",
                    {
                      staticClass: "onlyMyCheckbox",
                      staticStyle: { display: "inline !important" },
                      attrs: { value: "on" },
                      model: {
                        value: _vm.onlyMy,
                        callback: function($$v) {
                          _vm.onlyMy = $$v
                        },
                        expression: "onlyMy"
                      }
                    },
                    [_vm._v("\n          Мои офферы\n        ")]
                  )
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row mb-2" }, [
              _c(
                "div",
                {
                  staticClass:
                    "col-sm-5 col-md-3 col-lg-2 col-xl-2 mb-2 applyButton"
                },
                [
                  _c(
                    "b-input-group",
                    {},
                    [
                      _c("div"),
                      _vm._v(" "),
                      _c(
                        "b-input-group-append",
                        [
                          _c(
                            "b-btn",
                            {
                              staticClass: "mainButton",
                              staticStyle: {
                                "margin-right": "4px",
                                "border-top-left-radius": "0.2rem",
                                "border-bottom-left-radius": "0.2rem"
                              },
                              attrs: {
                                size: "sm",
                                text: "Search",
                                variant: "success"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.getOffers(
                                    1,
                                    {
                                      sortBy: _vm.sortBy,
                                      sortDesc: _vm.sortDesc
                                    },
                                    _vm.search,
                                    _vm.user
                                  )
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n              Применить\n              "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-btn",
                            {
                              staticClass: "mainButton",
                              attrs: { size: "sm", variant: "outline-danger" },
                              on: { click: _vm.resetFilters }
                            },
                            [_vm._v("Очистить\n              ")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-sm-12" }, [
                !_vm.isMobile
                  ? _c(
                      "div",
                      [
                        _c("b-table", {
                          ref: "selectableTable",
                          attrs: {
                            hover: "",
                            responsive: "",
                            bordered: "",
                            selectable: "",
                            "no-select-on-click": "",
                            small: "",
                            items: _vm.offers,
                            fields: _vm.fields,
                            "no-local-sorting": "",
                            "sort-by": _vm.sortBy,
                            "sort-desc": _vm.sortDesc,
                            "sort-direction": _vm.sortDirection
                          },
                          on: {
                            "update:sortBy": function($event) {
                              _vm.sortBy = $event
                            },
                            "update:sort-by": function($event) {
                              _vm.sortBy = $event
                            },
                            "sort-changed": function($event) {
                              return _vm.getOffers(1, $event, _vm.search)
                            },
                            "row-clicked": _vm.rowClickHandler,
                            "update:sortDesc": function($event) {
                              _vm.sortDesc = $event
                            },
                            "update:sort-desc": function($event) {
                              _vm.sortDesc = $event
                            }
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "cell(geo)",
                                fn: function(row) {
                                  return _vm._l(row.item.geo, function(
                                    item,
                                    index
                                  ) {
                                    return _c("div", [
                                      index < 2
                                        ? _c("div", [_vm._v(_vm._s(item))])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      index > 2 && index < 4
                                        ? _c(
                                            "div",
                                            [
                                              _c("i", {
                                                staticClass:
                                                  "icon-fa icon-fa-ellipsis-h",
                                                staticStyle: {
                                                  cursor: "pointer"
                                                },
                                                attrs: {
                                                  id: "geoPopover" + row.item.id
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "b-popover",
                                                {
                                                  attrs: {
                                                    "custom-class":
                                                      "offersPagePopover",
                                                    target:
                                                      "geoPopover" +
                                                      row.item.id,
                                                    triggers: "click"
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "template",
                                                    { slot: "title" },
                                                    [_vm._v("Все страны")]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "ol",
                                                    _vm._l(
                                                      row.item.geo,
                                                      function(geoItem) {
                                                        return _c("li", [
                                                          _vm._v(
                                                            _vm._s(geoItem)
                                                          )
                                                        ])
                                                      }
                                                    ),
                                                    0
                                                  )
                                                ],
                                                2
                                              )
                                            ],
                                            1
                                          )
                                        : _vm._e()
                                    ])
                                  })
                                }
                              },
                              {
                                key: "cell(type)",
                                fn: function(row) {
                                  return [
                                    row.item.type
                                      ? _c("div", [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(row.item.type.label) +
                                              "\n              "
                                          )
                                        ])
                                      : _vm._e()
                                  ]
                                }
                              },
                              {
                                key: "cell(user_id)",
                                fn: function(row) {
                                  return [
                                    _c("div", [
                                      _vm._v(_vm._s(row.item.user.name))
                                    ])
                                  ]
                                }
                              },
                              {
                                key: "cell(platforms)",
                                fn: function(row) {
                                  return _vm._l(row.item.platforms, function(
                                    item,
                                    index
                                  ) {
                                    return _c("div", [
                                      index < 2
                                        ? _c("div", [_vm._v(_vm._s(item))])
                                        : _vm._e()
                                    ])
                                  })
                                }
                              },
                              {
                                key: "cell(actions)",
                                fn: function(row) {
                                  return [
                                    row.item.user_id == _vm.$currentUser.id ||
                                    _vm.$currentUser.role == "admin"
                                      ? _c(
                                          "b-button",
                                          {
                                            staticClass: "btn btn-warning",
                                            attrs: { size: "sm" },
                                            on: {
                                              click: function($event) {
                                                $event.stopPropagation()
                                                return _vm.edit(row)
                                              }
                                            }
                                          },
                                          [
                                            _c("i", {
                                              staticClass:
                                                "icon-fa icon-fa-edit"
                                            })
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    row.item.user_id == _vm.$currentUser.id ||
                                    _vm.$currentUser.role == "admin"
                                      ? _c(
                                          "b-button",
                                          {
                                            staticClass: "btn btn-danger",
                                            attrs: { size: "sm" },
                                            on: {
                                              click: function($event) {
                                                $event.stopPropagation()
                                                return _vm.deleteOffer(row.item)
                                              }
                                            }
                                          },
                                          [
                                            _c("i", {
                                              staticClass:
                                                "icon-fa icon-fa-trash-o"
                                            })
                                          ]
                                        )
                                      : _vm._e()
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            2947352932
                          )
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.isMobile
                  ? _c(
                      "div",
                      [
                        _c("b-table", {
                          attrs: {
                            hover: "",
                            responsive: "",
                            bordered: "",
                            stacked: "",
                            small: "",
                            items: _vm.offers,
                            fields: _vm.fields,
                            "no-local-sorting": "",
                            "sort-by": _vm.sortBy,
                            "sort-desc": _vm.sortDesc,
                            "sort-direction": _vm.sortDirection
                          },
                          on: {
                            "update:sortBy": function($event) {
                              _vm.sortBy = $event
                            },
                            "update:sort-by": function($event) {
                              _vm.sortBy = $event
                            },
                            "sort-changed": function($event) {
                              return _vm.getOffers(1, $event, _vm.search)
                            },
                            "update:sortDesc": function($event) {
                              _vm.sortDesc = $event
                            },
                            "update:sort-desc": function($event) {
                              _vm.sortDesc = $event
                            }
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "cell(geo)",
                                fn: function(row) {
                                  return _vm._l(row.item.geo, function(
                                    item,
                                    index
                                  ) {
                                    return _c("div", [
                                      index < 2
                                        ? _c("div", [_vm._v(_vm._s(item))])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      index > 2 && index < 4
                                        ? _c("div", [
                                            _c("i", {
                                              staticClass:
                                                "icon-fa icon-fa-ellipsis-h"
                                            })
                                          ])
                                        : _vm._e()
                                    ])
                                  })
                                }
                              },
                              {
                                key: "cell(platforms)",
                                fn: function(row) {
                                  return _vm._l(row.item.platforms, function(
                                    item,
                                    index
                                  ) {
                                    return _c("div", [
                                      index < 2
                                        ? _c("div", [_vm._v(_vm._s(item))])
                                        : _vm._e()
                                    ])
                                  })
                                }
                              },
                              {
                                key: "cell(type)",
                                fn: function(row) {
                                  return [
                                    row.item.type
                                      ? _c("div", [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(row.item.type.label) +
                                              "\n              "
                                          )
                                        ])
                                      : _vm._e()
                                  ]
                                }
                              },
                              {
                                key: "cell(actions)",
                                fn: function(row) {
                                  return [
                                    row.item.user_id == _vm.$currentUser.id ||
                                    _vm.$currentUser.role == "admin"
                                      ? _c(
                                          "b-button",
                                          {
                                            staticClass: "btn btn-warning",
                                            attrs: { size: "sm" },
                                            on: {
                                              click: function($event) {
                                                $event.stopPropagation()
                                                return _vm.edit(row)
                                              }
                                            }
                                          },
                                          [
                                            _c("i", {
                                              staticClass:
                                                "icon-fa icon-fa-edit"
                                            })
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    row.item.user_id == _vm.$currentUser.id ||
                                    _vm.$currentUser.role == "admin"
                                      ? _c(
                                          "b-button",
                                          {
                                            staticClass: "btn btn-danger",
                                            attrs: { size: "sm" },
                                            on: {
                                              click: function($event) {
                                                $event.stopPropagation()
                                                return _vm.deleteOffer(row.item)
                                              }
                                            }
                                          },
                                          [
                                            _c("i", {
                                              staticClass:
                                                "icon-fa icon-fa-trash-o"
                                            })
                                          ]
                                        )
                                      : _vm._e()
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            1183709039
                          )
                        })
                      ],
                      1
                    )
                  : _vm._e()
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-sm-5" }, [
                _c(
                  "div",
                  { attrs: { role: "status", "aria-live": "polite" } },
                  [_vm._v("Всего записей: " + _vm._s(_vm.pager.total))]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-sm-7" }, [
                _c("div", { staticClass: "float-right" }, [
                  _c("nav", { attrs: { "aria-label": "Page navigation" } }, [
                    _c(
                      "ul",
                      { staticClass: "pagination justify-content-center" },
                      [
                        _c("b-pagination", {
                          attrs: {
                            size: "sm",
                            "total-rows": _vm.pager.total,
                            "per-page": _vm.pager.per_page
                          },
                          on: {
                            change: function($event) {
                              return _vm.getOffers(
                                $event,
                                { sortBy: _vm.sortBy, sortDesc: _vm.sortDesc },
                                _vm.search
                              )
                            }
                          },
                          model: {
                            value: _vm.pager.current_page,
                            callback: function($$v) {
                              _vm.$set(_vm.pager, "current_page", $$v)
                            },
                            expression: "pager.current_page"
                          }
                        })
                      ],
                      1
                    )
                  ])
                ])
              ])
            ]),
            _vm._v(" "),
            _c(
              "b-modal",
              {
                ref: "offerCreateModal",
                attrs: {
                  id: "createOffer",
                  "no-close-on-backdrop": true,
                  "no-enforce-focus": true,
                  "no-close-on-esc": true,
                  size: "md",
                  title: "Создать оффер",
                  "hide-footer": ""
                },
                on: { hidden: _vm.hideCreateModal }
              },
              [_c("CreateOfferModal")],
              1
            ),
            _vm._v(" "),
            _c(
              "b-modal",
              {
                ref: "offerEditModal",
                attrs: {
                  "no-close-on-backdrop": true,
                  "no-enforce-focus": true,
                  "no-close-on-esc": true,
                  id: "offerEditModal",
                  size: "md",
                  title: "Редактировать оффер",
                  "hide-footer": ""
                }
              },
              [_c("EditOfferModal", { attrs: { offer: _vm.selectedOffer } })],
              1
            ),
            _vm._v(" "),
            _c(
              "b-modal",
              {
                ref: "massOfferUpdateModal",
                attrs: {
                  id: "massOfferUpdateModal",
                  "ok-title": "Сохранить",
                  "cancel-title": "Отмена",
                  size: "sm",
                  title: "Редактирование Офферов"
                },
                on: { ok: _vm.massUpdate }
              },
              [
                _vm._l(_vm.massUpdateModal.errors, function(error) {
                  return _c("span", { staticClass: "alert-danger" }, [
                    _vm._v(_vm._s(error))
                  ])
                }),
                _vm._v(" "),
                _c(
                  "form",
                  [
                    _c(
                      "b-form-group",
                      { attrs: { label: "Тип" } },
                      [
                        _c("v-select", {
                          attrs: {
                            options: _vm.types,
                            reduce: function(type) {
                              return type.value
                            },
                            required: "",
                            searchable: false
                          },
                          model: {
                            value: _vm.massUpdateModal.type,
                            callback: function($$v) {
                              _vm.$set(_vm.massUpdateModal, "type", $$v)
                            },
                            expression: "massUpdateModal.type"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-form-group",
                      { attrs: { label: "Гео" } },
                      [
                        _c(
                          "v-select",
                          {
                            attrs: {
                              options: _vm.geo,
                              required: "",
                              multiple: ""
                            },
                            model: {
                              value: _vm.massUpdateModal.geo,
                              callback: function($$v) {
                                _vm.$set(_vm.massUpdateModal, "geo", $$v)
                              },
                              expression: "massUpdateModal.geo"
                            }
                          },
                          [
                            _c(
                              "span",
                              {
                                attrs: { slot: "no-options" },
                                slot: "no-options"
                              },
                              [_vm._v("Совпадений не найдено.")]
                            )
                          ]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-form-group",
                      { attrs: { label: "Платформа" } },
                      [
                        _c(
                          "v-select",
                          {
                            attrs: {
                              options: _vm.platforms,
                              required: "",
                              multiple: ""
                            },
                            model: {
                              value: _vm.massUpdateModal.platforms,
                              callback: function($$v) {
                                _vm.$set(_vm.massUpdateModal, "platforms", $$v)
                              },
                              expression: "massUpdateModal.platforms"
                            }
                          },
                          [
                            _c(
                              "span",
                              {
                                attrs: { slot: "no-options" },
                                slot: "no-options"
                              },
                              [_vm._v("Совпадений не найдено.")]
                            )
                          ]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-form-group",
                      { attrs: { label: "Рекламодатель" } },
                      [
                        _c(
                          "v-select",
                          {
                            attrs: {
                              options: _vm.advertisers,
                              reduce: function(advertiser) {
                                return advertiser.value
                              },
                              required: ""
                            },
                            model: {
                              value: _vm.massUpdateModal.selectedAdvertiser,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.massUpdateModal,
                                  "selectedAdvertiser",
                                  $$v
                                )
                              },
                              expression: "massUpdateModal.selectedAdvertiser"
                            }
                          },
                          [
                            _c(
                              "span",
                              {
                                attrs: { slot: "no-options" },
                                slot: "no-options"
                              },
                              [_vm._v("Совпадений не найдено.")]
                            )
                          ]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-form-group",
                      { attrs: { label: "Трекер" } },
                      [
                        _c("v-select", {
                          attrs: { options: _vm.trackers },
                          model: {
                            value: _vm.massUpdateModal.tracker,
                            callback: function($$v) {
                              _vm.$set(_vm.massUpdateModal, "tracker", $$v)
                            },
                            expression: "massUpdateModal.tracker"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-form-group",
                      { attrs: { label: "Валюта оффера" } },
                      [
                        _c("v-select", {
                          attrs: {
                            options: _vm.currency,
                            searchable: false,
                            required: ""
                          },
                          model: {
                            value: _vm.massUpdateModal.currency,
                            callback: function($$v) {
                              _vm.$set(_vm.massUpdateModal, "currency", $$v)
                            },
                            expression: "massUpdateModal.currency"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              2
            )
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "page-header" }, [
      _c("h3", { staticClass: "page-title" }, [_vm._v("Офферы")])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3e0e8348", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3e0e8348","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/views/front/Offers.vue
// module id = 905
// module chunks = 0